import React from 'react';
import './index.less';

export interface BlockProps {
    title: React.ReactNode;
    id?: string;
    style?: React.CSSProperties;
    description: React.ReactNode;
    children?: React.ReactChild | React.ReactChild[];
}

function Block(props: BlockProps) {
    return (
        <div className="block" id={props.id} style={props.style}>
            <div className="title">
                <div className="title-main">{props.title}</div>
                <div className="description">{props.description}</div>
            </div>
            <div className="content">{props.children}</div>
        </div>
    );
}

export default React.memo(Block);
